<script setup lang="ts">
/**
 * Tints the input it wraps while its value still comes from the assistant.
 * Layout-neutral (`display: contents`) so it can be dropped around any existing field.
 */
defineProps<{ active?: boolean }>();
</script>

<template>
  <div class="contents" :class="{ ai_filled: active }">
    <slot />
  </div>
</template>

<style scoped lang="scss">
/* The tint lands on the inner chrome of CommonInput / SimpleDropdown / TagDropdown / the rich-text editor. */
.ai_filled {
  :deep(.common_input__container),
  :deep(.multiselect__tags),
  :deep(input.input__default),
  :deep(.tiptap) {
    @apply bg-ai-surface-color border-ai-stroke-color;
  }
}
</style>
